import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type EmailDropProps = {
  center?: boolean
  isOver?: boolean
  text: string
}

const EmailDrop: React.FC<EmailDropProps> = ({ center, isOver, text }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div
        className={clsx(
          classes.content,
          center && classes.contentCenter,
          isOver && classes.contentOver
        )}
      >
        <div className={clsx(classes.text, center && classes.textCenter)}>
          Attach email{text ? ` to ${text}` : ''}
        </div>
      </div>
    </div>
  )
}

export default EmailDrop
